import { selectDeviceTree } from 'console/redux/devices/tree/selectors';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { getGroupsNameWithPath, } from 'console/left-menu/set-device-tree-group/utils';
import * as lodash from 'lodash';
export const getOptions = (groups, newIndexForOldPath) => {
    const groups_name = [];
    const last_path = newIndexForOldPath.length - 1;
    if (newIndexForOldPath.length !== 1)
        groups_name.push({
            name: 'В корневую папку',
            id: '-1',
        });
    for (const [index, group] of groups.entries()) {
        let show = true;
        if (group.path[last_path] !== undefined &&
            newIndexForOldPath[last_path] === group.path[last_path]) {
            show = false;
        }
        if (lodash.isEqual([...newIndexForOldPath].slice(0, -1), group.path)) {
            show = false;
        }
        if (show) {
            groups_name.push({
                name: group.name,
                id: index.toString(),
            });
        }
    }
    return groups_name;
};
export const useDisableAddToGroup = (node) => {
    const device_tree = useAppSelector(selectDeviceTree);
    const groups = getGroupsNameWithPath(device_tree);
    if (!node || !('children' in node))
        return false;
    const node_path = groups.find((el) => el.id === node.id);
    if (!node_path)
        return false;
    const options = getOptions(groups, node_path.path);
    return options.length > 0 ? false : true;
};
